import { render, staticRenderFns } from "./afterSalesStatistic.vue?vue&type=template&id=6f0d2bc8&scoped=true"
import script from "./afterSalesStatistic.vue?vue&type=script&lang=js"
export * from "./afterSalesStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0d2bc8",
  null
  
)

export default component.exports